import React from "react";
import compose from "lodash/fp/compose";
import gql from "graphql-tag";
import { graphql } from "react-apollo";

import { convertMutationErrors } from "../shared/util/graphql";

import LicenseView from "./ui/LicenseView";

const setQuery = gql`
  {
    licenseSet {
      id
      name
      settings
    }
  }
`;

const createMutation = gql`
  mutation($input: CreateLicenseInput!) {
    create: createLicense(input: $input) {
      license {
        id
      }
      errors {
        key
        message
      }
    }
  }
`;

const updateMutation = gql`
  mutation($input: UpdateLicenseInput!) {
    update: updateLicense(input: $input) {
      license {
        id
      }
      errors {
        key
        message
      }
    }
  }
`;

const deleteMutation = gql`
  mutation($input: DeleteLicenseInput!) {
    delete: deleteLicense(input: $input) {
      license {
        id
      }
    }
  }
`;

class C extends React.Component {
  handleCreate = async (values) => {
    const { data, createMutation } = this.props;
    const result = await createMutation({ variables: { input: values } });
    const errors = result.data.create.errors;
    if (errors) {
      return convertMutationErrors(errors);
    }
    await data.refetch();
  };

  handleUpdate = async ({ id, ...values }) => {
    const { data, updateMutation } = this.props;
    const result = await updateMutation({
      variables: { input: { ...values, id } },
    });
    const errors = result.data.update.errors;
    if (errors) {
      return convertMutationErrors(errors);
    }
    await data.refetch();
  };

  handleDelete = async ({ id }) => {
    const { data, deleteMutation } = this.props;
    await deleteMutation({ variables: { input: { id } } });
    await data.refetch();
  };

  render() {
    return (
      <LicenseView
        data={this.props.data}
        onCreate={this.handleCreate}
        onUpdate={this.handleUpdate}
        onDelete={this.handleDelete}
      />
    );
  }
}

const LicenseScene = compose(
  graphql(createMutation, { name: "createMutation" }),
  graphql(updateMutation, { name: "updateMutation" }),
  graphql(deleteMutation, { name: "deleteMutation" }),
  graphql(setQuery, { options: { fetchPolicy: "network-only" } })
)(C);

export default LicenseScene;
